import { useMemo } from 'react';

import { TransactionPricingOfferPayload } from 'types/graphql';

import { useQuery } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import {
    GET_ACTIVE_TRANSACTION_PRICING_OFFER,
    GET_ACTIVE_TRANSACTION_PRICING_OFFER_FOR_PARTNER,
} from 'src/graphql/queries/getActiveTransactionPricingOffers.query';

export const TRANSACTION_PRICING_OFFER_ID_KEY = 'transactionPricingOfferId';
export const useTransactionPricing = (partnerId?: number) => {
    const {
        data: activeTransactionPricingOffersData,
        loading: fetchingActiveTransactionOffers,
        refetch: refetchActiveTransactionOffers,
    } = useQuery(GET_ACTIVE_TRANSACTION_PRICING_OFFER, {
        onError: () => {
            return showErrorToast('Failed to fetch active transaction offers');
        },
        fetchPolicy: 'network-only',
    });

    const {
        data: activeTransactionPricingOffersDataForPartner,
        loading: fetchingActiveTransactionOffersForPartner,
        refetch: refetchPartnerTransactionPricingOffers,
    } = useQuery(GET_ACTIVE_TRANSACTION_PRICING_OFFER_FOR_PARTNER, {
        variables: { partnerId },
        skip: !partnerId,
        onError: () => {
            return showErrorToast('Failed to fetch active transaction offers for partner');
        },
        fetchPolicy: 'network-only',
    });

    const activeTransactionPricingOffers: TransactionPricingOfferPayload[] = useMemo(() => {
        refetchPartnerTransactionPricingOffers();

        return activeTransactionPricingOffersData?.getActiveTransactionPricingOffers ?? [];
    }, [activeTransactionPricingOffersData, refetchPartnerTransactionPricingOffers]);

    const activeTransactionPricingOffersForPartner: TransactionPricingOfferPayload[] =
        useMemo(() => {
            return (
                activeTransactionPricingOffersDataForPartner?.getActiveTransactionPricingOffersForPartner ??
                []
            );
        }, [activeTransactionPricingOffersDataForPartner]);

    return {
        fetchingActiveTransactionOffers,
        fetchingActiveTransactionOffersForPartner,
        activeTransactionPricingOffers,
        activeTransactionPricingOffersForPartner,
        TRANSACTION_PRICING_OFFER_ID_KEY,
        refetchActiveTransactionOffers,
    };
};
